import useTranslate from '@core/hooks/useTranslate';
import { ADMIN_FORWARDER_MENU } from '@root/core/constants/Forwarder/forwarder-menu';
import ChangePass from '@root/modules/Authentication/ForgotPass/pages/ChangePass';
import DetailedForwarder from '@root/modules/Forwarder/Detail/pages/ForwarderDetail';
import ForwarderInbound from '@root/modules/Forwarder/Inbound/pages/ForwarderInbound';
import MyPage from '@root/modules/Forwarder/My/pages/MyPage';
import SellerDetail from '@root/modules/Forwarder/Seller-Detail/pages/SellerDetail';
import ForwarderSeller from '@root/modules/Forwarder/Seller/pages/ForwarderSeller';

import { Layout, Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, Redirect, Route, Switch, useLocation } from 'react-router-dom';

const { Sider, Content } = Layout;
interface Props {
  path?: string;
}

const ForwarderSidebar = ({ path = '' }: Props) => {
  const [t] = useTranslate();
  const [collapsed, setCollapsed] = useState(false);
  const [selected, setSeclected] = useState('');
  const [a, setA] = useState([] as any);
  const activeItem = (event: any) => {
    setSeclected(event.key);
  };
  const location = useLocation();

  useEffect(() => {
    let a = location;
    const b = a.pathname.replace('/admin/', '').split('/');
    setA(b);
  }, [location]);

  const colorParent = (item: {
    id: number;
    name?: string;
    label?: string;
    url: string;
    children?: { id: number; name: string; url: string }[];
  }) => {
    let isBold =
      !a[1] && item.url == '/admin/forwarder'
        ? 'bold'
        : a[1] == item.url.replace('/admin/forwarder/', '')
        ? 'bold'
        : !!a[1] &&
          a[1]
            .replace('/admin/forwarder/', '')
            .split('-')
            .includes(item.url.replace('/admin/forwarder/', ''))
        ? 'bold'
        : '500';
    return isBold;
  };

  const colorHasChild = (item: {
    id: number;
    name?: string;
    label?: string;
    url?: string;
    children: { id: number; name: string; url: string }[];
  }) => {
    let isbold = false;
    item.children.forEach((child) => {
      let bold =
        !!a[1] && !a[2] && a[1] == child.url.replace('/admin/forwarder/', '')
          ? true
          : !!a[2] &&
            a[2] == child.url.replace('/admin/forwarder/' + a[1] + '/', '')
          ? true
          : !!a[2] &&
            child.url.includes(a[1]) &&
            child.url
              .replace('/admin/forwarder/', '')
              .split('/')[0]
              .includes(a[1])
          ? true
          : false;
      if (bold) isbold = true;
    });
    return isbold ? 'bold' : '500';
  };

  const renderAdminOrStoreHeader = () => {
    return (
      <>
        <Layout className="navigation">
          <Sider collapsedWidth="48" width="230" className="side-bar__menu">
            <Menu
              mode="inline"
              style={{ height: '100%', borderRight: 0 }}
              selectedKeys={[path]}
            >
              {ADMIN_FORWARDER_MENU.map((item: any, index: number) => (
                <>
                  {item.children ? (
                    <Menu.SubMenu
                      title={item.label}
                      key={index + 200}
                      style={{ fontWeight: colorHasChild(item) }}
                    >
                      {item.children.map((child: any, idx: number) => (
                        <>
                          {child.children ? (
                            <Menu.SubMenu
                              title={child.label}
                              key={index + 400}
                              style={{ fontWeight: colorHasChild(child) }}
                            >
                              {child.children.map(
                                (childChild: any, childChildIdx: number) => (
                                  <Menu.Item
                                    key={idx + index * 10 + childChildIdx * 10}
                                  >
                                    <Link
                                      to={childChild.url}
                                      style={{
                                        fontWeight:
                                          childChild.url ===
                                            location.pathname ||
                                          (childChild.hiddenChildren &&
                                            childChild.hiddenChildren.find(
                                              (h: any) =>
                                                h.url === location.pathname ||
                                                h.url.test(location.pathname)
                                            ))
                                            ? 'bold'
                                            : '500'
                                      }}
                                    >
                                      {t(childChild.name)}
                                    </Link>
                                  </Menu.Item>
                                )
                              )}
                            </Menu.SubMenu>
                          ) : (
                            <Menu.Item key={idx + index * 10}>
                              <Link
                                to={child.url}
                                style={{
                                  fontWeight:
                                    !!a[1] &&
                                    !a[2] &&
                                    a[1] ==
                                      child.url.replace('/admin/forwarder/', '')
                                      ? 'bold'
                                      : (!!a[2] &&
                                          (a[2] ==
                                            child.url.replace(
                                              '/admin/forwarder/' + a[1] + '/',
                                              ''
                                            ) ||
                                            (!isNaN(a[2]) &&
                                              child.url.replace(
                                                '/admin/forwarder/' + a[1],
                                                ''
                                              ) == ''))) ||
                                        (child.hiddenChildren &&
                                          child.hiddenChildren
                                            .map((v: any) => v.url)
                                            .includes(location.pathname))
                                      ? 'bold'
                                      : '500'
                                }}
                              >
                                {t(child.name)}
                              </Link>
                            </Menu.Item>
                          )}
                        </>
                      ))}
                    </Menu.SubMenu>
                  ) : (
                    <Menu.Item
                      className={'menu-nav'}
                      title={item.label}
                      onClick={(event) => activeItem(event)}
                      key={index + 300}
                    >
                      <Link
                        key={item.id + 1000}
                        to={item.url}
                        style={{
                          color:
                            selected === `tmp_key-${index}` ? '#0077ff' : '',
                          fontWeight: colorParent(item)
                        }}
                      >
                        {t(item.name)}
                      </Link>
                    </Menu.Item>
                  )}
                </>
              ))}
            </Menu>
          </Sider>
          <Layout>
            <Content
              style={{
                minHeight: 280,
                minWidth: 1080,
                overflow: 'scroll'
              }}
            >
              <Switch>
                <Route path="/reset-password/:token">
                  <ChangePass />
                </Route>
                <Route exact={true} path="/admin/forwarder/inbound">
                  <ForwarderInbound />
                </Route>
                <Route path="/admin/forwarder/inbound/:id">
                  <DetailedForwarder />
                </Route>
                <Route exact path="/admin/forwarder/seller">
                  <ForwarderSeller />
                </Route>
                <Route path="/admin/forwarder/seller/:id">
                  <SellerDetail />
                </Route>
                <Route path="/admin/forwarder/my">
                  <MyPage />
                </Route>
                <Route path="">
                  <Redirect to="/admin/forwarder/inbound" />
                </Route>
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </>
    );
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(ForwarderSidebar);
